import { render, staticRenderFns } from "./rating.vue?vue&type=template&id=0077ef58&scoped=true"
import script from "./rating.vue?vue&type=script&lang=js"
export * from "./rating.vue?vue&type=script&lang=js"
import style0 from "./rating.vue?vue&type=style&index=0&id=0077ef58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0077ef58",
  null
  
)

export default component.exports